import {
    forwardRef,
    ForwardRefExoticComponent,
    PropsWithChildren,
    ReactElement,
    Ref,
    RefAttributes,
} from 'react';

import './Wrapper.scss';

interface WrapperProps {
    className?: string;
}

type WrapperWithRefProps = WrapperProps & PropsWithChildren & RefAttributes<HTMLDivElement>;

export const Wrapper: ForwardRefExoticComponent<WrapperWithRefProps> = forwardRef(({
    className = '',
    children,
}, ref: Ref<HTMLDivElement>): ReactElement => (
    <div ref={ref} className={`wrapper ${className}`}>
        {children}
    </div>
));
